import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=3f526ace&scoped=true&xmlns%3Av-hammer=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./Welcome.vue?vue&type=script&lang=js&"
export * from "./Welcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f526ace",
  null
  
)

export default component.exports